import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';

export const RoleLogs = React.memo(() => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.roles.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs entityName={'ROLE'} id={id} isAdminLogs={false} service={'uaa'} />
      </div>
    </HasAccess>
  );
});
